import script from "./VoucherList.vue?vue&type=script&setup=true&lang=ts"
export * from "./VoucherList.vue?vue&type=script&setup=true&lang=ts"

import "./VoucherList.vue?vue&type=style&index=0&id=5fde798a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5fde798a"]])

export default __exports__